import React, { useState, useEffect } from "react";
import { Box, Paper, Typography } from "@material-ui/core";
import {
  FormActionDrawer,
  IntroText,
  LogoVaxYes,
  Sheet,
  SheetContent
} from "../../../components";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import { useConsumerAuth } from "../../../hooks";
import { parsePhoneNumber } from "libphonenumber-js";

const VaxYesRegister = () => {
  const [drawerClearance, setDrawerClearance] = useState(0);
  const { t } = useTranslation();
  const history = useHistory();
  const { phone_number } = useConsumerAuth();

  const [country, setCountry] = useState("US");

  const handleNext = () => history.push("/vaxyes/register/start");

  useEffect(() => {
    const { country } = parsePhoneNumber(phone_number);

    if (country === "MX") setCountry("MX");
  }, []);

  return (
    <Sheet
      data-cy="vax-yes-register-view"
      style={{ paddingBottom: `${drawerClearance}px` }}
    >
      <SheetContent>
        <Box mb={2}>
          <Paper>
            <Box p={2}>
              <Box textAlign="center" mb={2}>
                <LogoVaxYes height="50px" />
              </Box>
              <IntroText>
                {country === "US"
                  ? t("vax_yes.vax_yes_register.intro_text")
                  : t("vax_yes.vax_yes_register.intro_text_non_us")}
              </IntroText>
              <Typography>
                {country === "US"
                  ? t("vax_yes.vax_yes_register.secondary_text")
                  : t("vax_yes.vax_yes_register.secondary_text_non_us")}
              </Typography>
              <FormActionDrawer
                handleNext={() => handleNext()}
                setDrawerClearance={setDrawerClearance}
                nextButtonLabel={t("vax_yes.vax_yes_register.button")}
              />
            </Box>
          </Paper>
        </Box>
      </SheetContent>
    </Sheet>
  );
};

export { VaxYesRegister };
